import { HttpContext, HttpContextToken } from '@angular/common/http';

/** When true, the loan-application API error interceptor will not show a toast (caller handles UX). */
export const SUPPRESS_LOAN_APPLICATION_API_ERROR = new HttpContextToken<boolean>(
  () => false,
);

/** When true, successful mutation responses will not show a success toast (caller handles UX). */
export const SUPPRESS_LOAN_APPLICATION_API_SUCCESS = new HttpContextToken<boolean>(
  () => false,
);

/** Optional dialog title; defaults to "Unable to complete request". */
export const LOAN_APPLICATION_API_ERROR_TITLE = new HttpContextToken<string>(() => '');

export type LoanApplicationRequestOptions = {
  suppressGlobalError?: boolean;
  suppressGlobalSuccess?: boolean;
  errorTitle?: string;
};

export function loanApplicationHttpOptions(
  opts: LoanApplicationRequestOptions = {},
): { context: HttpContext } {
  return {
    context: new HttpContext()
      .set(SUPPRESS_LOAN_APPLICATION_API_ERROR, opts.suppressGlobalError ?? false)
      .set(SUPPRESS_LOAN_APPLICATION_API_SUCCESS, opts.suppressGlobalSuccess ?? false)
      .set(LOAN_APPLICATION_API_ERROR_TITLE, opts.errorTitle?.trim() ?? ''),
  };
}

/** LA-US-044/045: feedback only on writes — not list/read GET traffic. */
export function isLoanApplicationMutationRequest(method: string, url: string): boolean {
  if (!isLoanApplicationManagedApiUrl(url)) {
    return false;
  }
  const verb = method.toUpperCase();
  return verb === 'POST' || verb === 'PUT' || verb === 'PATCH' || verb === 'DELETE';
}

export function isLoanApplicationManagedApiUrl(url: string): boolean {
  return (
    /\/applications(\/|$|\?)/.test(url) ||
    /\/bureau-pulls(\/|$|\?)/.test(url) ||
    /\/documents\/[^/?#]+/.test(url) ||
    /\/integrations\/ocr\/parse(\/batch)?(\/|$|\?)/.test(url)
  );
}
